import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round align-middle text-lg leading-none" }, "info_outline", -1)
const _hoisted_2 = { class: "align-middle" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: "block mt-5 text-xs text-primary",
      id: "show-instructions",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("  "),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _ctx.handleOk,
      "cancel-button-props": { hidden: true},
      "ok-button-props": {shape: 'round', size: 'large'}
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          innerHTML: _ctx.$t(`Glavni predmet slike (dvorišče) pozicionirajte na sredino zaslona.<br>
        Položaj objektiva naj bo v višini vaših oči oz. vsaj 150 cm odaljenosti od tal in usmerjen vodoravno.<br>
        V sliki poiskusite zajeti celotno površino sicer pa lahko posamično dodate več različnih lokacij.
        Vsekakor priporočamo slikanje ob dnevni svetlobi.<br>
        Nikoli ne slikamo proti izviru svetlobe.`)
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ]))
}